<template>
    <div class="my-get-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar v-bind:titleData="titleData" v-bind:backFunc="clickBack"></title-bar>
        <!-- 2. 主要内容部分 -->
        <div class="my-get-content" @click="clickInputCursor">
            <p class="my-get-text">请输入6位数字接收密码</p>
            <div class="my-get-input-list dsp-flex">
                <div class="my-get-input-item" v-for="(inputText, index) in inputNum" :key="index">
                    <span class="my-get-input-text">{{inputText}}</span>
					<span class="my-get-input-cursor" v-if="inputFocused[index]"></span>
                </div>
                <input class="my-get-input" ref="numinput" type="number" @focus="focusNumber" @input="inputNumber" v-model="inputValue">
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import { UA } from '../../modules/utils';
export default {
    name: 'MyGet',
    components: { TitleBar },
    data() {
        return {
            titleData: {'titleText': '输入接收密码', 'showCancel': false},
            inputValue: '',
            inputNum: ['', '', '', '', '', ''],
            inputFocused: [false, false, false, false, false, false],
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            if(!UA.isIphone()) {
                me.clickInputCursor();
            }
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = innerHeight + 'px';
            var contentDom = document.getElementsByClassName('my-get-content')[0];
            if(contentDom) {
                contentDom.style.height = innerHeight+'px';
            }
        },
        clickBack() {
            this.$router.replace('/my');
        },
        focusNumber() {
            this.inputValue = '';
            this.inputNum = ['', '', '', '', '', ''];
            this.inputFocused = [true, false, false, false, false, false];
        },
        inputNumber() {
            if(this.inputValue.length >= 6) {
                this.inputValue = this.inputValue.slice(0, 6);
            }
            // console.error('inputNumber----', this.inputValue)
            var me = this, tempArr = this.inputValue.split('');
            for(var i = 0; i < this.inputNum.length; i++) {
                this.inputNum[i] = tempArr[i] ? tempArr[i] : '';
                this.inputFocused[i] = i==tempArr.length ? true : false;
            }
            if(tempArr.length >= 6) {
                this.$refs.numinput.blur();
                this.$store.dispatch('record/getShareCodeInfo', {
                    code: this.inputValue,
                    sucCb: function() {
                        me.$router.replace('/my/getbzselect');
                    },
                    failCb: function() {
                        me.$toast('分享码错误，请重新输入')
                    }
                })
            }
        },
        clickInputCursor() {
            this.$refs.numinput.focus();
        }
    }
}
</script>